import React from 'react';

import {ResourcesFolderItem} from '../../../containers/student/ResourcesFolderItem';
import {NavigationMenuItem} from './NavigationMenuItem';
import {Item, ResourcesFolder} from '@ael/core-api';
import {MenuItemLabel} from '@ael/shared-components-library';
import AnimateHeight from 'react-animate-height';

import './ResourceFolderNavigationMenuItem.scss';

interface ResourceFolderNavigationMenuItemProps {
  item: ResourcesFolder;
  nestedLevel: number;
  getItemById: (itemId: string) => Item;
  isLinearModeOn: boolean;
  isStudent: boolean;
}

export const ResourceFolderNavigationMenuItem: React.FC<ResourceFolderNavigationMenuItemProps> = ({
  item,
  nestedLevel,
  getItemById,
  isLinearModeOn,
  isStudent,
}) => {
  const [resourcesExpanded, setResourcesFolderExpanded] = React.useState(false);
  const resources = item.resources;

  if (resources.count() === 0) {
    return null;
  }
  return (
    <>
      <ResourcesFolderItem
        item={item}
        key={item.id}
        expanded={resourcesExpanded}
        onClick={setResourcesFolderExpanded}
        isLinearModeOn={isLinearModeOn}
      >
        <MenuItemLabel>{item.title}</MenuItemLabel>
      </ResourcesFolderItem>
      {resources && (
        <AnimateHeight
          height={resourcesExpanded ? 'auto' : 0}
          duration={500}
          contentClassName="resource-folder-navgiation-menu-item__wrapper"
          className="resource-folder-navgiation-menu-item__wrapper-sizer"
        >
          {resources.map((itemId: string) => (
            <NavigationMenuItem
              key={itemId}
              itemId={itemId}
              parentItemId={item.id}
              nestedLevel={nestedLevel + 1}
              getItemById={getItemById}
              isLinearModeOn={isLinearModeOn}
              isStudent={isStudent}
            />
          ))}
        </AnimateHeight>
      )}
    </>
  );
};
